import type { ItemProperties } from '@atlassian/jira-dashboard-user-preference/src/types.tsx';
import { convertUserPrefsToColumnNames } from './convert-user-prefs-to-column-names.tsx';
import { getSortFieldAndDirection } from './get-sort-field-and-direction.tsx';
import { isFilterId } from './is-filter-id.tsx';

export const transformToValidUserPrefs = (rawUserPrefs: ItemProperties) => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const pageSize = parseInt(rawUserPrefs.num as string, 10);
	const fieldSetIds = convertUserPrefsToColumnNames(rawUserPrefs.columnNames);
	const stringifiedFilterId = `${rawUserPrefs.filterId}`;

	const { sortDirection, sortField } = getSortFieldAndDirection(rawUserPrefs.sortBy);
	const showResolved = !!rawUserPrefs.showResolved;
	return {
		filterId: isFilterId(stringifiedFilterId) ? stringifiedFilterId : undefined,
		columnNames: fieldSetIds,
		num: !Number.isNaN(pageSize) ? pageSize : 10,
		sortDirection,
		sortField,
		showResolved,
	};
};
